import React from 'react';
import { createBrowserHistory } from 'history';
import { Router } from 'react-router-dom';

import './App.scss';
import Header from '../header/index'
import HeroArea from '../hero-area/index'
// import AnperSection from '../anper-section/index'
import CategorySection from '../category-section/index'
// import ContentSection01 from '../content-section-01/index'
import ContentSection02 from '../content-section-02/index'
import ContentSection03 from '../content-section-03/index'
import ContentSection04 from '../content-section-04/index'
import StatsSection from '../stats-section/index'
import AwardSection from '../award-section/index'
import Footer from '../footer/index'

import ReactGA from 'react-ga';

const history = createBrowserHistory();

class App extends React.Component{

  constructor(){
    super();
    const trackingId = "UA-145243581-4"; // PP DCH 2019
    ReactGA.initialize(trackingId);

    history.listen(location => {
      ReactGA.set({ page: location.pathname }); // Update the user's current page
      ReactGA.pageview(location.pathname); // Record a pageview for the given page
    });


  }
  
  render(){
    return (
      <Router history={history}>
        <div className="App">
            <Header />
            <HeroArea />
            <CategorySection /> {/*Categories*/}
            {/* <ContentSection01 /> */}
            <ContentSection02 /> {/*About*/}
            <StatsSection /> {/*Stats*/}
            <ContentSection03 /> {/*Timeline*/}
            <ContentSection04 /> {/*FAQ*/}
            <AwardSection />
            <Footer />
            <footer className="py-4 bg-dark text-white-50">
              <div className="container text-center">
                <small>Built with ♥ by Dept. Teknologi Informasi & Digital PT. PP (Persero) Tbk. </small>
                <br/>
                <small>Copyright &copy;  Digital Construction Hack 2019</small>
              </div>
            </footer>

        </div>
      </Router>

    );
  }
}

export default App;
